var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "5 5 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11163 10.5223C8.56283 6.3111 12.8743 5.13298 14.9736 5.07031C17.0729 5.13298 21.3843 6.3111 21.8355 10.5223C22.3995 15.7862 21.7415 17.4782 23.4335 18.9822C24.7871 20.1854 25.0001 21.0502 24.9375 21.3322C24.9688 21.8961 24.5614 23.0241 22.6814 23.0241H14.9736H7.26571C5.38573 23.0241 4.97835 21.8961 5.00967 21.3322C4.947 21.0502 5.16006 20.1854 6.51365 18.9822C8.20563 17.4782 7.54764 15.7862 8.11163 10.5223Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8457,
    y: 3,
    width: 2.25598,
    height: 3.19597,
    rx: 1.12799,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0645 24.0547C11.3381 25.9679 12.9835 27.4387 14.9724 27.4387C16.9613 27.4387 18.6067 25.9679 18.8804 24.0547H11.0645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification_bell.9ab3eb71139c0c1703e4660e21b19cd0.svg";
export { ForwardRef as ReactComponent };